/** @deprecated */
export function createSerieId(name: string) {
  return `serie-${name}`
}
